import { render } from "./Help.vue?vue&type=template&id=50e19e0f"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "50e19e0f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50e19e0f', script)) {
    api.reload('50e19e0f', script)
  }
  
  module.hot.accept("./Help.vue?vue&type=template&id=50e19e0f", () => {
    api.rerender('50e19e0f', render)
  })

}

script.__file = "src/components/help/Help.vue"

export default script